import {useToast as useChakraToast, UseToastOptions} from '@chakra-ui/react';

export const useToast = (options?: UseToastOptions) => {
  const toast = useChakraToast({
    position: 'top-right',
    isClosable: true,
    duration: 3000,
    ...options,
  });

  return {
    success: (title?: string) => toast({title, status: 'success'}),
    error: (title?: string) => toast({title, status: 'error'}),
    warn: (title?: string) => toast({title, status: 'warning'}),
    toast,
  };
};
